import React from "react";
import "./accordian.scss";
// import { useToggle } from "../../hooks";
import Chevron from "../../../assets/icons/chevron.svg";
import { useRipple } from "../../hooks";

const Accordian = ({ title, children, open, onClick }) => {
  // const [open, toggle] = useToggle(false);
  const [showRipple, ripples] = useRipple({ opacity: 0.07 });
  return (
    <div className="accordian">
      <button
        className={`accordian__button ${open && "accordian__button--open"}`}
        onClick={onClick}
      >
        <span className="accordian__title">{title}</span>
        <div className="accordian__icon" onClick={showRipple}>
          <Chevron
            className={`accordian__chevron ${
              open && "accordian__chevron--open"
            }`}
          />
          {ripples}
        </div>
      </button>
      <div
        className={`accordian__content ${open && "accordian__content--open"}`}
      >
        <p className={`accordian__text ${open && "accordian__text--open"}`}>
          {children}
        </p>
      </div>
    </div>
  );
};

export default Accordian;
